export const initialState = {
  items: [],
  isFetching: false,
  isFetched: false,
}

export const setItems = (state, payload) => (
  { ...state, items: payload, isFetching: false, isFetched: true }
)

export const setFetching = (state, payload) => (
  { ...state, isFetching: payload }
)
